import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { GatsbyImage, GatsbyImageProps } from "gatsby-plugin-image";
import React, { FC } from "react";
import useImage from "../hooks/useImage";

type ImageProps = Omit<GatsbyImageProps, "image"> & {
  name: string;
};

/**
 * This component displays an image from the images folder.
 *
 * If the image is not found, an error message will be displayed instead.
 *
 * @param name The name of the image file, without the file extension.
 * @param props The props to be passed to the `GatsbyImage` component.
 */

const Image: FC<ImageProps> = ({ name, ...props }) => {
  const imageToShow = useImage(name);

  if (!imageToShow)
    return (
      <Stack
        justifyContent="center"
        alignItems="center"
        sx={{ width: "100%", height: "100%", backgroundColor: "error.main" }}
      >
        <Typography variant="h3">
          Image not found, are you sure the name is correct?
          <br />
          Remember to add the image to the images folder
          <br />
          File extension should be omitted from the name
          <br />
          name: {name}
        </Typography>
      </Stack>
    );

  return (
    <GatsbyImage
      style={{ height: "100%", width: "100%" }}
      objectFit="cover"
      image={imageToShow}
      {...props}
    />
  );
};

export default Image;
